import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import CustomLoader from "../../global/components/CustomLoader/CustomLoader";
import { theme } from "../../utils/styles";
import ragChatbotStyles from "./RagChatbot.styles";
import ChatArea from "./components/ChatArea";
import FileUploadArea from "./components/FileUploadArea";

const RagChatbot = () => {
  const classes = ragChatbotStyles;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>("chat");

  // Add uploading files state here
  const [uploadingFiles, setUploadingFiles] = useState<File[]>([]);
  const [showUploadingTable, setShowUploadingTable] = useState<boolean>(false);
  const [selectedFileInfo, setSelectedFileInfo] = useState<{
    fileName: string;
    category: string;
  } | null>(null);

  const handleChatClick = (fileName: string, category: string) => {
    setSelectedFileInfo({ fileName, category });
    setSelectedTab("chat");
  };

  const tabItems = [
    { key: "upload", label: `${t("documents")}` },
    { key: "chat", label: `${t("ragChatbot")}` },
  ];

  const getComponentBasedOnValue = () => {
    switch (selectedTab) {
      case "upload":
        return (
          <FileUploadArea
            setIsLoading={setIsLoading}
            uploadingFiles={uploadingFiles}
            setUploadingFiles={setUploadingFiles}
            showUploadingTable={showUploadingTable}
            setShowUploadingTable={setShowUploadingTable}
            onChatClick={handleChatClick}
          />
        );
      case "chat":
        return (
          <ChatArea
            setIsLoading={setIsLoading}
            selectedFileInfo={selectedFileInfo}
            setSelectedFileInfo={setSelectedFileInfo}
          />
        );
      default:
        return (
          <ChatArea
            setIsLoading={setIsLoading}
            selectedFileInfo={selectedFileInfo}
            setSelectedFileInfo={setSelectedFileInfo}
          />
        );
    }
  };

  const getTabs = () => {
    return (
      <Stack
        direction={"row"}
        spacing={{ md: 4, xs: 2.5 }}
        pl={{ sm: 5, xs: 0 }}
        pb={1}
        pt={{ md: 0, xs: 1 }}
        justifyContent={"center"}
        sx={classes.menuItems}
      >
        {tabItems.map((item) => {
          return (
            <Typography
              key={item.key}
              sx={
                selectedTab === item.key
                  ? { ...classes.selectedCardLabel, cursor: "pointer" }
                  : { ...classes.cardLabel, cursor: "pointer" }
              }
              onClick={() => setSelectedTab(item.key)}
            >
              {item.label}
            </Typography>
          );
        })}
      </Stack>
    );
  };

  const getRagChatbot = () => {
    return (
      <>
        <Box sx={classes.mainContainer}>
          <Box sx={classes.mainBox}>
            <Box sx={classes.subBox}>
              <Box sx={classes.containerScrollStyle}>
                {getTabs()}
                {getComponentBasedOnValue()}
              </Box>
            </Box>
          </Box>
        </Box>
        <CustomLoader isLoading={isLoading} />
      </>
    );
  };
  return getRagChatbot();
};

export default RagChatbot;
